import {motion} from 'framer-motion';
import * as FaIcons from 'react-icons/fa';
import SafeIcon from '../common/SafeIcon';
import {contact} from '../data/contact';
import '../demos-links.css';

const {FaFacebook,FaYoutube,FaGlobe}=FaIcons;

const videoLinks=[
  {
    label: 'Our Facebook video page',
    href: 'https://www.facebook.com/pg/duranmediasolutions/videos',
    icon: FaFacebook,
    brand: 'facebook'
  },
  {
    label: 'Our YouTube channel',
    href: contact.youtubeUrl,
    icon: FaYoutube,
    brand: 'youtube'
  }
];

const clientSites=[
  'http://wordlifeconnection.org/',
  'https://casablancaeasttower.com/',
  'https://casablancawesttower.com/',
  'https://omarrah.com/'
];

const listVariants={hidden: {},show: {transition: {staggerChildren: 0.12}}};

const itemVariants={
  hidden: {opacity: 0,x: -30},
  show: {opacity: 1,x: 0,transition: {type: 'spring',stiffness: 110,damping: 16}}
};

function LinkItem({label,href,icon,brand}) {
  return (
    <motion.li variants={itemVariants}>
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className={brand ? `brand-link brand-${brand}` : ''}
      >
        <span className="link-label">
          <SafeIcon icon={icon || FaGlobe} className="link-logo" aria-hidden="true" focusable="false" />
          <span>{label}</span>
        </span>
        <SafeIcon name="ArrowUpRight" aria-hidden="true" focusable="false" />
      </a>
    </motion.li>
  );
}

function SocialBadge({item,delay}) {
  return (
    <motion.a
      href={item.href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={item.label}
      className={`social-badge badge-${item.brand}`}
      animate={{y: [0,-8,0]}}
      transition={{duration: 3,repeat: Infinity,ease: 'easeInOut',delay}}
      whileHover={{scale: 1.18,rotate: -8}}
      whileTap={{scale: 0.95}}
    >
      <SafeIcon icon={item.icon} aria-hidden="true" focusable="false" />
    </motion.a>
  );
}

function DemoLinks() {
  return (
    <section className="demo-links" aria-label="More of our work">
      <motion.div
        className="demo-links-block"
        initial={{opacity: 0,y: 40}}
        whileInView={{opacity: 1,y: 0}}
        viewport={{once: true,amount: 0.3}}
        transition={{duration: 0.7}}
      >
        <div className="social-badges">
          {videoLinks.map((item,index)=> (
            <SocialBadge key={item.href} item={item} delay={index * 0.5} />
          ))}
        </div>
        <span className="section-tag">Video work</span>
        <h2>Watch our latest videos.</h2>
        <p>
          To view some of our video work,please visit our Facebook page! Or visit our YouTube channel.
        </p>
        <motion.ul
          className="link-list"
          variants={listVariants}
          initial="hidden"
          whileInView="show"
          viewport={{once: true}}
        >
          {videoLinks.map((item)=> (
            <LinkItem key={item.href} {...item} />
          ))}
        </motion.ul>
      </motion.div>
      <motion.div
        className="demo-links-block"
        initial={{opacity: 0,y: 40}}
        whileInView={{opacity: 1,y: 0}}
        viewport={{once: true,amount: 0.3}}
        transition={{duration: 0.7,delay: 0.15}}
      >
        <span className="section-tag">Client sites</span>
        <h2>Sites we have produced.</h2>
        <p>Here are some links to client sites we have produced.</p>
        <motion.ul
          className="link-list"
          variants={listVariants}
          initial="hidden"
          whileInView="show"
          viewport={{once: true}}
        >
          {clientSites.map((href)=> (
            <LinkItem
              key={href}
              label={href.replace(/^https?:\/\//,'').replace(/\/$/,'')}
              href={href}
            />
          ))}
        </motion.ul>
      </motion.div>
    </section>
  );
}

export default DemoLinks;